import changeOptions from "../product/change-options";

/**
 * Close Modal
 */
const closeModal = () => {
  const $modal = $(".modal");

  $modal.on("click", ".js-modal-close, .modal__overlay", function (event) {
    event.preventDefault();
    const $this = $(this);
    const $currentModal = $this.closest(".modal");
    $currentModal.removeClass("is-open");

    if (
      $(".drawer.is-active").length > 0 ||
      $(".modal-aside.expanded").length > 0
    ) {
      return;
    } else {
      $("body").removeClass("no-scroll");
    }
  });
};

closeModal();
